module.exports = __webpack_public_path__ + "img/customer_service.2b43e616.jpg";